import { render, staticRenderFns } from "./ContainerObservacao.vue?vue&type=template&id=021244ce&scoped=true"
import script from "./ContainerObservacao.vue?vue&type=script&lang=js"
export * from "./ContainerObservacao.vue?vue&type=script&lang=js"
import style0 from "./ContainerObservacao.vue?vue&type=style&index=0&id=021244ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021244ce",
  null
  
)

export default component.exports